import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const SignupFormAction = ({ title, children, error = false, titleClassName = '' }) => (_jsxs("div", Object.assign({ className: 'flex flex-col md:flex-row pt-5 py-5 items-top' }, { children: [_jsxs("div", Object.assign({ className: 'w-full md:w-1/3 text-left' }, { children: [_jsx("p", Object.assign({ className: `font-light mr-0 md:mr-10 mb-3 md:mb-0 ${titleClassName}` }, { children: title })), error && _jsx("p", Object.assign({ className: 'input-error text-viva-red text-sm' }, { children: error }))] })), _jsx("div", Object.assign({ className: 'w-full md:w-2/3 flex justify-center md:justify-start flex-wrap' }, { children: children }))] })));
SignupFormAction.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    error: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
    ]),
    titleClassName: PropTypes.string
};
export default SignupFormAction;
